import { msg } from '@gonfalon/messages/msg';
import clsx from 'clsx';

import { DataExportScope } from '../../../utils/combineDataExportUsage';

import styles from './DataExportLegend.module.css';

type DataExportLegendProps = {
  selectedScope: DataExportScope;
  onChange: (scope: DataExportScope) => void;
};

const SCOPE_COLOR_TOKENS: Record<DataExportScope, string> = {
  [DataExportScope.BOTH]: '--lp-color-data-info',
  [DataExportScope.WAREHOUSE]: '--lp-color-data-series-1',
  [DataExportScope.STREAMING]: '--lp-color-fill-feedback-warning',
};

export function getDataExportScopeColor(scope: DataExportScope): string | undefined {
  if (scope === DataExportScope.BOTH) {
    return undefined;
  }
  const value = getComputedStyle(document.documentElement).getPropertyValue(SCOPE_COLOR_TOKENS[scope]).trim();
  return value || undefined;
}

const ITEMS = [
  { scope: DataExportScope.BOTH, label: () => msg('billing.dataExportCombined.both') },
  { scope: DataExportScope.WAREHOUSE, label: () => msg('billing.dataExportCombined.warehouse') },
  { scope: DataExportScope.STREAMING, label: () => msg('billing.dataExportCombined.streaming') },
];

export function DataExportLegend({ selectedScope, onChange }: DataExportLegendProps) {
  return (
    <div role="group" aria-label={msg('billing.dataExportCombined.scopeLabel')} className={styles.legend}>
      {ITEMS.map(({ scope, label }) => (
        <button
          key={scope}
          type="button"
          aria-pressed={scope === selectedScope}
          className={clsx(styles.item, scope !== selectedScope && styles.unselected)}
          onClick={() => onChange(scope)}
        >
          <span
            aria-hidden
            data-test-id={`legend-dot-${scope}`}
            className={styles.dot}
            style={{ backgroundColor: `var(${SCOPE_COLOR_TOKENS[scope]})` }}
          />
          {label()}
        </button>
      ))}
    </div>
  );
}
